import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, DynamicFormModule, SystemIconModule } from '@serviceos-ng/core';
import { RateBookingModalComponent } from './rate-booking-modal.component';
import { TipProModule } from '../tip-pro/tip-pro.module';



@NgModule({
  declarations: [RateBookingModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    DynamicFormModule,
    SystemIconModule,
    TipProModule
  ],
  exports: [RateBookingModalComponent]
})
export class RateBookingModalModule { }
